<template>
    <v-container class="unauthenticated fill-height" fluid>
            <v-row class="unauthenticated_logincard" align="center" justify="center">
                <v-col cols="12" md="8">
                    <v-card elevation="3" class="mx-auto align-center justify-center" width="550px">
                        <v-card elevation="0" color="#004236">
                            <v-row align-content="center" justify="center">
                                <v-col cols="5"><v-img src="../../assets/backgrounds/KingsLogoinWhite.png" contain></v-img></v-col>
                            </v-row>
                        </v-card><br /><br />
                        <v-row align-content="center" justify="center">
                            <v-col cols="12"></v-col>
                            <v-col cols="6" class="ma-0 pa-0"><span class="text-h5 text-center" style="margin-left:auto;">Welcome to the SFS Portal</span></v-col>
                            <v-col cols="8" class="ma-0 pa-0">
                                <v-progress-linear
                                    color="#d7ae28"
                                    rounded
                                    value="100"
                                ></v-progress-linear>
                            </v-col>
                        </v-row><br /><br /><br/>
                        <v-spacer></v-spacer>
                        <v-row align-content="center" justify="center">
                            <v-col cols="8">
                                <v-btn ref="staffBtn" @click="staffLogin()" :href="staffLink" raised color="#004236" class="white--text" block>
                                    Sign in as staff
                                </v-btn>
                            </v-col>
                            <v-col cols="8">
                                <v-btn ref="studentBtn" @click="studentLogin()" :href="studentLink" raised color="#004236" class="white--text" block>
                                    Sign in as student
                                </v-btn>
                            </v-col> 
                        </v-row><br />
                    </v-card>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'unauthenticated',
    data() {
        return {
            staffLink: `https://${location.hostname}/cgi-bin/mkvn/app.pl?staff&redirect=1`,
            studentLink: `https://${location.hostname}/cgi-bin/mkvn/app.pl?student&redirect=1`
        }
    },
    methods: {
        staffLogin() {
            this.$refs.staffBtn.loading = true;
        },
        studentLogin() {
            this.$refs.studentBtn.loading = true;
        }
    }
}
</script>

<style scoped>
.headline {
    word-break: normal;
}
.unauthenticated{
    background-image: url('../../assets/backgrounds/unauthenticated_bg.jpg');

    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>